export default __webpack_public_path__ + "static/aws-424483d69158adc77184c151222cf3b7.png";